<template>
<table>
  <thead>
  <th>CONFIRMAÇÃO</th>
  <th>ENTR. GELAD. VELHA</th>
  <th>DOCUCMENTAÇÃO</th>
  <th>ENTR. GELAD. NOVA</th>
  </thead>
  <tbody>
  <tr>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
  </tr>
  </tbody>
</table>
</template>

<script>
export default {
  name: 'StagesTableTicket'
}
</script>

<style scoped>
  table {
    border-spacing: 0.5rem;
    width: 100%;
  }

  td, th {
    text-align: center;
    border: 1px solid #999;
    padding: 0.5rem;
  }

  th {
    background-color: #ddd;
  }

  td {
    padding-bottom: 4em;
    width: 25%;
  }

</style>



// WEBPACK FOOTER //
// src/components/Trg/Documents/TicketsRegister/StagesTableTicket.vue